import { BipPayment, DefaultPage, ThankyouPage } from './';

import ThankyouTerminalPage from './ThankyouTerminalPage';

export default {
  path: '/',
  name: 'Home',
  childRoutes: [
    { path: 'es', name: 'Default page', component: DefaultPage },
    { path: 'es/pasajes-bus', name: 'Default page', component: DefaultPage },

    { path: 'en', name: 'Default page', component: DefaultPage },
    { path: 'en/bus-tickets', name: 'Default page', component: DefaultPage },

    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    {
      path: 'e-bookings/:originId/:originName/:destId/:destName/:onwardDate',
      name: 'Default page',
      component: DefaultPage,
      isIndex: true,
    },
    {
      path: 'bank-transfer/booking/:status/:pnrNumber',
      name: 'Default page',
      component: ThankyouPage,
      isIndex: true,
    },

    {
      path: 'bank-transfer/booking/:status',
      name: 'Default page',
      component: ThankyouPage,
      isIndex: true,
    },
    {
      path: 'add-card/:status/:pnrNumber',
      name: 'Default page',
      component: ThankyouPage,
      isIndex: true,
    },
    {
      path: 'terminal-booking/:status',
      name: 'Default page',
      component: ThankyouTerminalPage,
      isIndex: true,
    },
  ],
};
// http://kupas.cl/e-bookings/1646/Santiago/1905/Osorno/21-12-2019?trip_type=1&operator_id=140&is_from_operator_seo=true

//http://www.pbstage.kupas.cl/api/ui_schedules.json?origin_id=1841&destination_id=1986&travel_date=2020-03-29&show_only_available_services=false&show_injourney_services=true



// WEBPACK FOOTER //
// ./src/features/home/route.js